import { object, string, number, boolean, array, ObjectSchema, InferType, mixed } from "yup";
import { EditarEmpresaContract } from "../contracts/editar-empresa";
import { UnitOfMeasureEnum } from "../../../shared/components/formulario/select/SelectUnitOfMeasure";

export const editarEmpresaSchema: ObjectSchema<EditarEmpresaContract> = object({
  fullName: string().nullable().default(null).optional(),
  fantasyName: string().nullable().default(null).optional(),
  email: string().required("E-mail é obrigatório!").email("E-mail inválido!"),
  phone: string().required("Telefone é obrigatório!"),
  address: object({
    zipCode: string().required("CEP é obrigatório!"),
    street: string().required("Rua é obrigatória!"),
    number: string().required("Número é obrigatório!"),
    neighborhood: string().required("Bairro é obrigatório!"),
    city: string().required("Cidade é obrigatória!"),
    state: string().required("Estado é obrigatório!"),
    complement: string().nullable().default(null).optional(),
  }).required("Endereço é obrigatório!"),
  isClt: boolean().required("Informe se a empresa possui funcionários CLT!"),
  companyConfig: object({
    id: string().nullable().optional().default(null),
    alicota: string().required("Alíquota do Simples Nacional é obrigatória!"),
    cancelFinancialMovement: boolean().required("Informe se o movimento financeiro será cancelado!"),
    cancellationPeriod: number().required("Período de cancelamento é obrigatório!").typeError("Período de cancelamento deve ser um número!"),
  }).required("Configuração da empresa é obrigatória!"),
  chargesClt: object({
    id: string().nullable().optional().default(null),
    fgtsPercent: number().required("Percentual do FGTS é obrigatório!").typeError("Percentual do FGTS deve ser um número!"),
    fgtsTerminationFine: number().required("Multa rescisória do FGTS é obrigatória!").typeError("Multa rescisória do FGTS deve ser um número!"),
    inssEmployerPercent: number().required("Percentual do INSS patronal é obrigatório!").typeError("Percentual do INSS patronal deve ser um número!"),
    ratPercent: number().required("Percentual do RAT é obrigatório!").typeError("Percentual do RAT deve ser um número!"),
    vacationPercent: number().required("Percentual de férias é obrigatório!").typeError("Percentual de férias deve ser um número!"),
    thirteenthSalaryPercent: number().required("Percentual do décimo terceiro é obrigatório!").typeError("Percentual do décimo terceiro deve ser um número!"),
    oneThirdVacationPercent: number().required("Percentual de um terço de férias é obrigatório!").typeError("Percentual de um terço de férias deve ser um número!"),
    fgtsOnProvisionsPercent: number().required("Percentual do FGTS sobre provisões é obrigatório!").typeError("Percentual do FGTS sobre provisões deve ser um número!"),
  })
    .when('isClt', {
      is: true,
      then: (schema) => schema.required("Encargos CLT obrigatórios quando empresa possui funcionários CLT!"),
      otherwise: (schema) => schema.optional().default(undefined),
    }),
  profitMarginBudget: array(
    object({
      id: string().nullable().default(null).optional(),
      name: string().required("Nome do orçamento é obrigatório!"),
      value: number().required("Valor do orçamento é obrigatório!").typeError("Valor do orçamento deve ser um número!"),
    })
  ).required("Lista de margens de lucro é obrigatória!"),
  laborBudget: array(
    object({
      id: string().optional().default(undefined),
      isClt: boolean().required("Informe se o orçamento de mão de obra é CLT!"),
      description: string().required("Descrição do cargo é obrigatória!"),
      unitOfMeasure: mixed<UnitOfMeasureEnum>().oneOf(Object.values(UnitOfMeasureEnum)).required("Unidade de medida é obrigatória!"),
      baseWage: number()
        .typeError("Salario base deve ser um número")
        .transform((value, originalValue) => {
          if (typeof originalValue === "string") {
            const cleaned = originalValue.replace(/\./g, "").replace(",", ".").replace(/[^0-9.]/g, "");
            if (!cleaned) return undefined;
            const valorNumber = Number(cleaned);
            return isNaN(valorNumber) ? undefined : valorNumber;
          }
          return value;
        })
        .when('isClt', {
          is: true,
          then: schema => schema.required("Salario base é obrigatório para CLT!"),
          otherwise: schema => schema.optional(),
        }),
      wage: number()
        .typeError("Salário deve ser um número")
        .transform((value, originalValue) => {
          if (typeof originalValue === "string") {
            const cleaned = originalValue.replace(/\./g, "").replace(",", ".").replace(/[^0-9.]/g, "");
            if (!cleaned) return undefined;
            const valorNumber = Number(cleaned);
            return isNaN(valorNumber) ? undefined : valorNumber;
          }
          return value;
        })
        .when('isClt', {
          is: false,
          then: schema => schema.required("Salário é obrigatório para não CLT!"),
          otherwise: schema => schema.optional()
        }),
    })
  ).required("Lista de orçamentos de mão de obra é obrigatória!"),
});

export type EditarEmpresaFormData = InferType<typeof editarEmpresaSchema>;
